<template>
  <div class="content-wrapper">
    <div class="content">
      <div class="bg-white border rounded">
        <div
          v-if="user.roles != undefined && user.roles.includes('ROLE_SELLER')"
          class="text-center card-title card-white"
          style="margin-top:2%;"
        >
          <h3>{{ $t("store.details") }}</h3>
        </div>
        <div
          v-if="user.roles != undefined && user.roles.includes('ROLE_SELLER')"
          class="row no-gutters"
        >
          <div class="col-8 offset-2">
            <div class="card px-3 px-xl-5">
              <div class="card-body card-white show">
                <div class="mt-5">
                  <form method="post" @submit.prevent="addStore">
                    <div class="row mb-2">
                      <div class="col-12">
                        <div class="form-group">
                          <label for="name">{{ $t("attr.name") }}</label>
                          <input
                            type="text"
                            :class="
                              'form-control ' +
                                {
                                  'is-invalid': has_error && errors.name,
                                }
                            "
                            id="name"
                            v-model="store.name"
                          />
                          <span
                            class="help-block text-danger"
                            v-if="has_error && errors.name"
                            >{{ errors.name[0] }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-8">
                        <div class="form-group">
                          <label for="address">{{ $t("attr.address") }}</label>
                          <input
                            type="text"
                            :class="
                              'form-control ' +
                                {
                                  'is-invalid': has_error && errors.address,
                                }
                            "
                            id="address"
                            v-model="store.address"
                          />
                          <span
                            class="help-block text-danger"
                            v-if="has_error && errors.address"
                            >{{ errors.address[0] }}</span
                          >
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="form-group">
                          <label for="phone">{{ $t("attr.phone") }}</label>
                          <input
                            type="text"
                            :class="
                              'form-control ' +
                                {
                                  'is-invalid':
                                    has_error && errors.phone_number,
                                }
                            "
                            id="phone_number"
                            v-model="store.phone_number"
                          />
                          <span
                            class="help-block text-danger"
                            v-if="has_error && errors.phone_number"
                            >{{ errors.phone_number[0] }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="form-group row mb-6">
                      <label for="storeImage" class="col-4 col-form-label">{{
                        $t("attr.cover-photo")
                      }}</label>
                      <div class="col-8">
                        <div class="custom-file mb-1">
                          <input
                            type="file"
                            v-bind:class="
                              'custom-file-input' +
                                {
                                  'is-invalid': has_error && errors.cover_photo,
                                }
                            "
                            id="coverPhoto"
                            name="coverPhoto"
                            ref="coverPhoto"
                            v-on:change="onCoverPhotoChange"
                          />
                          <label class="custom-file-label" for="coverPhoto"
                            >{{ $t("action.chooseFile") }}...</label
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        coverPhotoPreview !== '' || store.cover_photo !== null
                      "
                      class="form-group row mb-6"
                    >
                      <div class="col-8">
                        <div class="custom-file mb-1">
                          <img
                            :src="
                              coverPhotoPreview !== ''
                                ? coverPhotoPreview
                                : storageUrl + store.cover_photo
                            "
                            class="thumbnail"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-8">
                        <div class="form-group">
                          <label for="address">{{ $t("attr.address") }}</label>
                          <input
                            type="text"
                            :class="
                              'form-control ' +
                                {
                                  'is-invalid': has_error && errors.address,
                                }
                            "
                            id="address"
                            v-model="store.address"
                          />
                          <span
                            class="help-block text-danger"
                            v-if="has_error && errors.address"
                            >{{ errors.address[0] }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-8">
                        <div class="form-group">
                          <label for="description">{{
                            $t("attr.description")
                          }}</label>
                          <textarea
                            :class="
                              'form-control ' +
                                {
                                  'is-invalid': has_error && errors.description,
                                }
                            "
                            id="description"
                            v-model="store.description"
                          ></textarea>
                          <span
                            class="help-block text-danger"
                            v-if="has_error && errors.description"
                            >{{ errors.description[0] }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="form-group row mb-6">
                      <label for="storeImage" class="col-4 col-form-label">{{
                        $t("store.picture")
                      }}</label>
                      <div class="col-8">
                        <div class="custom-file mb-1">
                          <input
                            type="file"
                            v-bind:class="
                              'custom-file-input' +
                                {
                                  'is-invalid': has_error && errors.password,
                                }
                            "
                            id="picture"
                            name="picture"
                            ref="picture"
                            v-on:change="onPictureChange"
                          />
                          <label class="custom-file-label" for="picture"
                            >{{ $t("action.chooseFile") }}...</label
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="imagePreview !== '' || store.picture !== null"
                      class="form-group row mb-6"
                    >
                      <div class="col-8">
                        <div class="custom-file mb-1">
                          <img
                            :src="
                              imagePreview !== ''
                                ? imagePreview
                                : storageUrl + store.picture
                            "
                            class="thumbnail"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="d-flex justify-content-end mt-5">
                      <button
                        type="submit"
                        class="btn btn-primary mb-2 btn-pill"
                      >
                        {{ $t("action.confirm") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row" style="margin: 5%;">
          <div class="col-10 offset-1">
            <div class="alert alert-danger">
              <label class="label-control"
                >{{ $t("sentence.becomeASellerToAddStore") }}
                <router-link
                  :to="{
                    name: 'AccountInformations',
                  }"
                >
                  {{ $t("sentence.clickHereToBecomeASeller") }}</router-link
                ></label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config";
export default {
  data() {
    return {
      store: this.$store.state.store,
      has_error: false,
      error: "",
      errors: {},
      success: false,
      loader: false,
      config: config,
      storageUrl: config.storageUrl,
      newPicture: "",
      newCoverPhoto: "",
      imagePreview: "",
      coverPhotoPreview: "",
    };
  },
  mounted() {
    console.log(this.user);
    this.getStore(this.user.id);
  },
  methods: {
    onPictureChange() {
      this.newPicture = this.$refs.picture.files[0];

      this.imagePreview = URL.createObjectURL(this.newPicture);
    },
    onCoverPhotoChange() {
      this.newCoverPhoto = this.$refs.coverPhoto.files[0];

      this.coverPhotoPreview = URL.createObjectURL(this.newCoverPhoto);
    },
    getStore() {
      var self = this;
      this.$axios({
        url: "user/get/store",
        method: "GET",
      })
        .then((response) => {
          if (response.data.length > 0) {
            self.store = response.data[0];
          }
        })
        .catch(() => {});
    },
    addStore() {
      var self = this;
      self.loader = true;
      var formData = new FormData();

      formData.append("name", self.store.name);
      formData.append("address", self.store.address);
      formData.append("phone_number", self.store.phone_number);
      formData.append("description", self.store.description);

      if (self.newPicture !== undefined && self.newPicture !== "") {
        formData.append("picture", self.newPicture);
        self.store.picture = self.newPicture;
      }

      if (self.newCoverPhoto !== undefined && self.newCoverPhoto !== "") {
        formData.append("cover_photo", self.newCoverPhoto);
        self.store.coverPhoto = self.newCoverPhoto;
      }

      this.$axios({
        url: "store/create",
        method: "POST",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(() => {
          this.$store.state.store = self.store;
        })
        .catch((err) => {
          self.has_error = true;
          self.error = err.response.data.message;
          self.errors = err.response.data.data || {};
        });
      self.loader = false;
    },
  },
  computed: {
    user: {
      get() {
        return this.$store.state.user;
      },
      set(user) {
        this.$store.commit("setUser", { user: user });
      },
    },
  },
};
</script>
